import { type JSX, createContext, ReactNode, useState } from "react";
import { BaseSpaceConnectionCredentials } from "@via/utils/interfaces.tsx";

interface Props {
  children?: ReactNode;
}

export interface IBaseSpaceConnectionContext {
  connectionCredentials: BaseSpaceConnectionCredentials | null;
  setConnectionCredentials: (
    newCredentials: BaseSpaceConnectionCredentials | null
  ) => void;
}

const initial = {
  connectionCredentials: null,
  setConnectionCredentials: (): void => {},
};

const BaseSpaceConnectionContext =
  createContext<IBaseSpaceConnectionContext>(initial);

const BaseSpaceConnectionProvider = ({ children }: Props): JSX.Element => {
  const [connectionCredentials, setConnectionCredentials] =
    useState<BaseSpaceConnectionCredentials | null>(null);

  return (
    <BaseSpaceConnectionContext.Provider
      value={{ connectionCredentials, setConnectionCredentials }}>
      {children}
    </BaseSpaceConnectionContext.Provider>
  );
};

export { BaseSpaceConnectionContext, BaseSpaceConnectionProvider };
